import * as React from 'react';

import { type NonEmptyArray, getRangeValue, getTermValue, getTermsValue } from '@/packages/JsonQuery';
import { type EFloorTypes } from '@/packages/api-models/common/json_query';

import { Floor } from '../../../components/advancedFilters/Floor';
import { useFiltersContext } from '../../../utils/context';
import { useOfferType } from '../../../utils/useOfferType';

export const FloorContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const offerType = useOfferType();
  const floor = getRangeValue('floor')(jsonQuery);
  const isFirstFloor = getTermValue('is_first_floor')(jsonQuery);
  const notLastFloor = getTermValue('not_last_floor')(jsonQuery);
  const floorTypes = getTermsValue('floor_types')(jsonQuery);

  const handleFloorMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setFloorMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleFloorMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setFloorMax', arguments: [lte] });
    },
    [onChange],
  );

  const handleIsFirstFloorChange = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (isFirstFloor: boolean | null) => {
      onChange({ action: 'setIsFirstFloor', arguments: [isFirstFloor] });
    },
    [onChange],
  );

  const handleNotLastFloorChange = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (notLastFloor: boolean | null) => {
      onChange({ action: 'setNotLastFloor', arguments: [notLastFloor] });
    },
    [onChange],
  );

  const handleFloorTypesChange = React.useCallback(
    (value: NonEmptyArray<EFloorTypes> | null) => {
      onChange({ action: 'setFloorTypes', arguments: [value] });
    },
    [onChange],
  );

  return (
    <Floor
      floor={floor}
      floorTypes={floorTypes}
      isFirstFloor={isFirstFloor}
      notLastFloor={notLastFloor}
      offerType={offerType}
      onFloorMaxChange={handleFloorMaxChange}
      onFloorMinChange={handleFloorMinChange}
      onFloorTypesChange={handleFloorTypesChange}
      onIsFirstFloorChange={handleIsFirstFloorChange}
      onNotLastFloorChange={handleNotLastFloorChange}
    />
  );
};
